import React, { useRef, useState } from "react";
import { useAuth } from "../AuthContext";
import axios from "axios";

/**
 * Secure video player:
 * - No native download button
 * - No right-click (context menu)
 * - No seeking / fast-forward (progresses only forward via time updates)
 * - Sends session cookie for stream (query auth also supported by backend)
 */
export default function SecureVideoPlayer({ videoId, courseId, onEnded }) {
  const { API } = useAuth();
  const videoRef = useRef(null);
  const [lastTime, setLastTime] = useState(0);
  const [completed, setCompleted] = useState(false);

  const src = `${API}/videos/${videoId}/stream`;

  const handleTimeUpdate = (e) => {
    const v = e.target;
    // Prevent seeking forward: allow only sequential playback (tolerance 1.5s)
    if (v.currentTime - lastTime > 1.5) {
      v.currentTime = lastTime;
      return;
    }
    setLastTime(v.currentTime);
    if (!completed && v.duration && v.currentTime / v.duration > 0.9) {
      setCompleted(true);
      axios.post(`${API}/enrollments/${courseId}/progress`, { video_id: videoId }, { withCredentials: true }).catch(() => {});
      onEnded?.();
    }
  };

  const handleSeeking = (e) => {
    // Disable manual seeking (fast-forward / rewind beyond last time)
    if (Math.abs(e.target.currentTime - lastTime) > 1.5) {
      e.target.currentTime = lastTime;
    }
  };

  return (
    <div className="secure-video-wrapper" onContextMenu={(e) => e.preventDefault()} data-testid="secure-video-wrapper">
      <video
        ref={videoRef}
        src={src}
        controls
        controlsList="nodownload noplaybackrate noremoteplayback"
        disablePictureInPicture
        onTimeUpdate={handleTimeUpdate}
        onSeeking={handleSeeking}
        onContextMenu={(e) => e.preventDefault()}
        crossOrigin="use-credentials"
        data-testid="secure-video"
      >
        Your browser does not support video playback.
      </video>
      <div className="mt-2 overline">Downloads, seeking, and right-click are disabled.</div>
    </div>
  );
}
